<template>
  <fin-step-by-step-question
    :questionIndex="questionIndex"
    :selectable="value>=0"
    :selection-hint="value>=0 ? properties.values[value].tooltip.text : 'Wähle eine Antwort um mehr darüber zu erfahren.'"
    @next="$emit('next')"
    :value="value"
    :question=properties.question
    :questionTitle=properties.title
    :class="$vuetify.breakpoint.mdAndUp ? 'question' : ''"
    :hint="hint"
  >
    <div>
      <illu :value="value"
            :animations="animations"
            :tooltipTexts="properties.values"
            @input="val => $emit('input', val)"
            v-if="$vuetify.breakpoint.mdAndUp"/>
      <fin-step-by-step-carousel-answers v-else
                                         :animations="animations"
                                         :value="value"
                                         :answers="properties.values"
                                         @input="val => {this.$emit('input', val), this.$emit('next')}"
      />
    </div>

  </fin-step-by-step-question>
</template>

<script>
import FinStepByStepQuestion from '@/components/pages/onboarding/Step2/StepByStep/StepByStepQuestion/index'
import Illu from './Illu'
import FinStepByStepCarouselAnswers from "../Carousel/StepByStepCarouselAnswers"

export default {
  name: 'FinStepByStep3',
    components: {FinStepByStepCarouselAnswers, Illu, FinStepByStepQuestion},
  data () {
    return {
      selection: -1,
        hint: {
            title: 'Wie bestimme ich meine Risikoneigung?',
            texts: [
                {
                    content: 'Verschaffe dir zunächst einen Überblick, wie viel Verluste du dir bei der Geldanlage wirtschaftlich leisten könntest. Deine individuelle Risikotoleranz hängt insbesondere ab von Faktoren wie aktuelles Arbeitsverhältnis und Gehalt, bestehendes Vermögen/Schulden und der Dauer der Anlage.',
                },
                {
                    content: 'Kläre dann deine individuelle Risikobereitschaft bzw. beantworte dir selbst die Frage:'
                },
                {
                    content: 'Bin ich bereit, für eine höhere Rendite auch die Risiken von Kursschwankungen und möglichen Verlusten einzugehen?',
                    style: 'font-weight: bold'
                }
            ]
        }
    }
  },
  props: {
    value: {
        type: Number
    },
      questionIndex: {
          type: Number
    },
    properties: {
      type: Object
    },
      animations: {
          type: Array
      }
  }
}
</script>

<style lang="scss" scoped>
  .question {
    background: linear-gradient(to bottom, transparent 68%, #EDF1F4 0%);
  }
</style>
